<header >
    <div class="contenedorHead">
        <h1> Servicio Meteorológico de la <span class="bold">República Argentina</span></h1>
        <img src="../assets/imagenes/logo.png" alt="Logo">
    </div>
    <hr>
    <nav class="navegador">

        <a href="#/home" alt="Home con la descripción del sitio" matTooltip="Home con la descripción del sitio" [matTooltipShowDelay]="0" [matTooltipHideDelay]="1000" mat-button color="primary">Home</a>
        <a href="#/lista" alt="Lista de localidades y su estado meteorológico" matTooltip="Lista de localidades y su estado meteorológico" [matTooltipShowDelay]="0" [matTooltipHideDelay]="1000" mat-button color="primary">Lista</a>

    </nav>
</header>